import { Trans } from 'react-i18next';
import { TRUST_URL } from '../data/NavigationData';

// Highlighted "part of the Trust" badge, shown next to the logo in the main bar
// (desktop Menu.js and mobile SideBar.js) so it is always visible.
// Two lines: small intro text, then the trust name as a yellow link.
function TrustBadge() {
    return (
        <a className="trustBadge" href={TRUST_URL} target="_blank" rel="noreferrer">
            <span className="trustBadgeIntro"><Trans i18nKey="Trust umbrella" /></span>
            <span className="trustBadgeName"><Trans i18nKey="TRUST umbrella link" /></span>
        </a>
    );
}

export default TrustBadge;
